
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import CustomerStateHandler from '@root/common/components/helpers/CustomerStateHandler.vue';

interface Props {
  article: ArticleData;
}

interface Computed {
  isPressPelease: boolean;
  isPtContent: boolean;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  components: {
    CustomerStateHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isPressPelease() {
      const settings: any = this.article.settings;
      return !!settings['icon.press_release'];
    },
    isPtContent() {
      const settings: any = this.article.settings;
      return !!settings['icon.reklama'];
    },
  },
});
